export const LANGUAGES = [
  {
    id: 'pt',
    locale: 'pt',
    name: 'Português',
    default: true,
  },
  {
    id: 'en',
    locale: 'en',
    name: 'English',
    default: false,
  },
]
